import { render, staticRenderFns } from "./SelectBinLocationTo.vue?vue&type=template&id=f3819ac4&"
import script from "./SelectBinLocationTo.vue?vue&type=script&lang=js&"
export * from "./SelectBinLocationTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports